import { Children, isValidElement } from 'react';
export const safeGetChildrenArray = children => {
  const childArray = [];
  Children.forEach(children, child => {
    if ( /*#__PURE__*/isValidElement(child)) {
      childArray.push(child);
    }
  });
  return childArray;
};